import { render, staticRenderFns } from "./ShowEventModal.vue?vue&type=template&id=644311b1&scoped=true&lang=pug"
import script from "./ShowEventModal.vue?vue&type=script&lang=js"
export * from "./ShowEventModal.vue?vue&type=script&lang=js"
import style0 from "./ShowEventModal.vue?vue&type=style&index=0&id=644311b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644311b1",
  null
  
)

export default component.exports